import React, { useContext, useEffect, useState } from "react";
import styles from "./Login.module.css";
import "./toggle.css";
import { useNavigate } from "react-router-dom";
import AppContext from "../../store/AppContext";
import useHttp from "../../hook/use-http";
import { API_URL_MAIN } from "../../constants/driveglobalfilterinitalstates";
import getMobileOperatingSystem from "../../util/getMobileOperatingSystem";
import getOperatingSystem from "../../util/getOperatingSystem";
import * as $ from "jquery";
import { Buffer } from "buffer";
import ChartLoader from "../Shared/Loader";
import { LucideNotebookText } from "lucide-react"
import { PiBookFill } from "react-icons/pi";
import CustomTooltip from "../Shared/CustomTooltip";

function LandingPage({ keycloak }) {
  const [userid, setUserId] = useState("");
  const [pwd, setPwd] = useState("");
  const [evbus, setEv_Bus] = useState('FLEETEV');
  const [LoginError, setLoginError] = useState({});
  const [vehicleLoginFailed, setVehicleLoginFailed] = useState(false)

  const userID = keycloak?.idTokenParsed?.preferred_username

  const { specialAccess, setSpecialUsersAccess,...authctx } = useContext(AppContext);
  const navigate = useNavigate();
  const { isLoading, error, sendReq: fetchData } = useHttp();

  function encodeToBase64(input) {
    return Buffer.from(input, "utf8").toString("base64");
  }

  useEffect(() => {
    if (authctx.username != "" && authctx.username != null) {
      navigate("/homePage");
    }
  }, [authctx]);

  useEffect(() => {
    handlelogin();
  }, []);

  const [userTypeBeforeLogin, setuserTypeBeforeLogin] = useState({ type: "" });

  const handlelogin = async () => {

    try {
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      var encryptedData = encodeToBase64(pwd);
      let requestBody = {
        username: userID,
        device_id,
        os_sys,
      };
      fetchData({ url: API_URL_MAIN + "auth/checkPostLogin", body: requestBody, }, appyDataBeforeLogin);
    } catch (err) {
      setLoginError(err);
    }
  };


  const [usernameTempHideShow, setUsernameTempHideShow] = useState(false)
  const [tempOrgData, setTempOrgData] = useState("")
  const appyDataBeforeLogin = (data) => {

    setTempOrgData(data.access_typeTemp) //1,2,3,4....
    if (data.hasOwnProperty("status_msg")) {
      if (data.status_msg == "unauthorized") {
        setLoginError({ message: data.message });
      } else if (data.status_msg === "false") {

        alert(data.message);
      } else if (data.status_msg === "success") {

        setuserTypeBeforeLogin(prev => ({ ...prev, type: data.data }));

        setEv_Bus(data?.hasERC ? 'ERC' : 'FLEETEV')
      }
      if(userID){
        setSpecialUsersAccess(userID)
      }
    } else {
      setLoginError({ message: "Something went wrong" });
    }
  };

  const [buttonManage, setButtonManage] = useState([])

  const vehicleTypes = ["ACE", "BUS", "ORION", "CORAL", "KRATOS", "SUMMARY", "JUPITER"];

  const systems = {
    ERC: "ERC",
    FLEETEV: "FLEETEV",
  };

  useEffect(() => {
    if (!userTypeBeforeLogin?.type) return;
    const split_str = tempOrgData.split(",");
    if (split_str.includes("111")) {
      setUsernameTempHideShow(true);
    }

    const userTypes = userTypeBeforeLogin?.type?.split(",");
    let system = evbus == 'ERC' ? 'ERC' : 'FLEETEV'; // Either "ERC" or "FLEETEV"
    const matchedVehicles = vehicleTypes.filter((v) => {
      return userTypes.includes(`${system}_${v}`)
    }
    );

    if (matchedVehicles.length > 1) {
      const buttonData = matchedVehicles?.map((v) => ({
        id: `${system}_${v}`,
        label: v === "BUS" ? "CESL" :
          v === "CORAL" ? "ACE PRO EV" :
            v,

      }));
      setButtonManage(buttonData);
    } else if (matchedVehicles.length === 1) {
      LoginWithType(`${system}_${matchedVehicles[0]}`);
    } else {
      setLoginError({ message: "Select Proper application Type" });
    }
  }, [userTypeBeforeLogin, tempOrgData, evbus]);

  const LoginWithType = async (ev_bus_type) => {
    let device_id = getMobileOperatingSystem();
    let os_sys = getOperatingSystem(window);
    var encryptedData = btoa(pwd);
    let requestBody = {
      username: userID,
      password: encryptedData,
      ev_bus: ev_bus_type,
      device_id,
      os_sys,
    };
    fetchData({ url: API_URL_MAIN + "auth", body: requestBody, }, appyDataLogin);
  };

  const appyDataLogin = (data) => {
    authctx.login_user(data);
  };

  const popUpButtonClicked = (e) => {
    setEv_Bus(e.target.id);
    setwhichButton(e.target.id);
  };

  const [whichButton, setwhichButton] = useState("");
  useEffect(() => {
    if (whichButton != "") {
      doSomething();
    }
  }, [whichButton]);

  const doSomething = async () => {
    try {
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      var encryptedData = encodeToBase64(pwd);
      let requestBody = {
        username: userID,
        password: encryptedData,
        ev_bus: whichButton,
        device_id,
        os_sys,
      };

      fetchData({ url: API_URL_MAIN + "auth", headers: { "Content-Type": "application/json", }, body: requestBody, },
        (res) => {
          if (res.error == "unauthorized") {
            setVehicleLoginFailed(true)
          }
          else {
            appyDataLogin(res)
          }
        }
      );
    } catch (err) {
      setLoginError(err);
    }
  };

  var el = document.querySelectorAll(".togglebtn");
  for (let i = 0; i < el.length; i++) {
    el[i].onclick = function () {
      var c = 0;
      while (c < el.length) {
        el[c++].className = "togglebtn removed";
      }
      el[i].className = "togglebtn active";
    };
  }

  return (
    <>
      {
        isLoading ? <ChartLoader height={80} width={80} /> :
          <div
            id="LoginModal"
            style={{
              position: "fixed",
              zIndex: 1,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              pointerEvents: "none"
            }}
          >
            <div className="modal-content modal-sm">
              <div className="modal-header" style={{ padding: "8px" }}>
                <h5 className="modal-title">Select Project</h5>
              </div>

              <div className="modal-body" style={{ padding: "8px" }}>
                {
                  vehicleLoginFailed ? <>Something went wrong</> :
                    Array.isArray(buttonManage) &&
                    buttonManage.map((btn, index) => (
                      <button
                        key={btn.id}
                        type="button"
                        onClick={popUpButtonClicked}
                        id={btn.id}
                        disabled={isLoading}
                        className={`btn btn-primary w-100 ${index > 0 ? "mt-1" : ""
                          } ${styles["btn-primary"]} ${styles["btn"]}`}
                      >
                        {btn.label}
                      </button>
                    ))}

                {(usernameTempHideShow && evbus === "ERC") &&
                  ["CYGNUS", "MAGNA", "INTERCITY", "CERUS"].map(label => (
                    <button
                      key={label}
                      type="button"
                      className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}
                    >
                      <img
                        src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"}
                        className={styles["work_in_progress_img"]}
                        alt={label}
                      />
                      <span>{label}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
      }
      <div className={styles.background}>
        <header className=" p-3">
          <div className="d-flex justify-content-between ">
            <div className="p-2 bd-highlight" style={{ position: 'relative' }}>
              <img src={process.env.PUBLIC_URL + "assets/img/tml_wt.png"} className={`img-fluid ${styles.ttlLogo}`} />
              <br />
              <img src={process.env.PUBLIC_URL + "assets/img/only_for_tml.png"} className={`img-fluid ${styles.nly_fo_tml}`} style={{ position: 'absolute' }} />
            </div>
            <div className="p-2 bd-highlight">
              {
                specialAccess?.landing_page_guidebook ?
                <CustomTooltip text="Go to Guide Book" placement="bottom" textColor="#fff">
                  <span
                    onClick={() => navigate("/guide-book")}>
                    <PiBookFill className="custom-Btn-animation text-white mr-2" size={30} />
                  </span>
                </CustomTooltip>:<></>
              }
              <img src={process.env.PUBLIC_URL + "assets/img/sparqplug_logo.png"} className={`img-fluid ${styles.spargPlgLogo}`} />
            </div>
          </div>
        </header>
      </div >
    </>
  );
}

export default LandingPage;
